import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const createCrisisData = async (data) => {

  try {
    let res = await Api.post("/crisis-data", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getCrisisData = async (query) => {
  try {
    let res = await Api.get("/crisis-data", {
      params: query,
    });
  
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};



export const deleteCrisisData = async (id) => {
  try {
    let res = await Api.delete("/crisis-data/" + id);
  
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updateCrisisData = async (id, data) => {
  try {
    let res = await Api.patch("/crisis-data/" + id, data);
  
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to Update" };
  }
};

export const updatePosition = async(banners, query)=>{
  try {
    let res = await Api.patch("/crisis-data/relocate-position", banners, {
      params: query,
    });
  
    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
}